export function setReservationCodeType(type) {
    localStorage.setItem('xs_reservation_print_type', type);
}
